import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const CanvasGraphQLReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="canvasGraphQLReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={form.formState.errors.name?.message}
      />
      <FormField
        controlId="canvasGraphQLReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={form.formState.errors.type?.message}
      />
      <FormField
        controlId="canvasGraphQLReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="canvasGraphQLReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="canvasGraphQLReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      <FormField
        controlId="canvasGraphQLReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="canvasGraphQLReaderFormRootUrl"
        label="rootUrl"
        name="properties.rootUrl"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter root URL"
        error={errors?.properties?.rootUrl?.message}
      />
      <FormField
        controlId="canvasGraphQLReaderFormPath"
        label="path"
        name="properties.path"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter path"
        required
        error={form.formState.errors.properties?.path?.message}
      />
      <FormField
        controlId="canvasGraphQLReaderFormAccessToken"
        label="accessToken"
        name="properties.accessToken"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter access token"
        error={errors?.properties?.accessToken?.message}
      />
      <FormField
        controlId="canvasGraphQLReaderFormVariables"
        label="variables"
        name="properties.variables"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
        rows={10}
        placeholder="Enter variables"
        error={errors?.properties?.variables?.message}
      />
      <FormField
        controlId="canvasGraphQLReaderFormQuery"
        label="query"
        name="properties.query"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        rows={10}
        placeholder="Enter GraphQL query"
        required
        error={form.formState.errors.properties?.query?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default CanvasGraphQLReaderForm;
